import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMascot = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 126 140",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 85.742,
			cy: 134.042,
			rx: 26.919,
			ry: 5.95745,
			fill: "#F0F1F3"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 54.3365,
			cy: 90.8511,
			rx: 54.3365,
			ry: 7.44681,
			fill: "#F0F1F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M82.3977 22.4704C82.3978 22.4704 82.3981 22.4703 82.1291 21.5072C81.8601 20.544 81.8606 20.5439 81.8613 20.5437L81.8635 20.5431L81.8706 20.5411L81.8958 20.5342C81.9173 20.5284 81.9485 20.52 81.9889 20.5093C82.0697 20.4879 82.1876 20.4573 82.3403 20.4193C82.6455 20.3434 83.0898 20.2378 83.654 20.117C84.782 19.8756 86.3917 19.5728 88.3297 19.3248C92.1979 18.8297 97.4113 18.5476 102.726 19.4277C108.042 20.308 113.521 22.3616 117.834 26.5892C122.161 30.8306 125.219 37.1658 125.852 46.4193C126.956 62.5559 121.634 74.2662 117.772 82.7647C117.229 83.9595 116.715 85.0907 116.252 86.1619C115.308 88.3436 114.593 90.2321 114.241 91.8996C113.891 93.5589 113.918 94.92 114.378 96.0894C115.25 98.3072 117.882 100.302 124.135 102.035C124.668 102.183 124.992 102.728 124.855 103.263V103.263C124.717 103.797 124.169 104.12 123.637 103.973C117.273 102.214 113.764 99.9939 112.517 96.8213C111.864 95.1611 111.887 93.3692 112.284 91.4867C112.68 89.6123 113.464 87.5705 114.416 85.3679C114.892 84.2686 115.414 83.1183 115.961 81.9124C119.816 73.4146 124.924 62.1579 123.857 46.5557C123.251 37.6984 120.35 31.8558 116.434 28.0175C112.504 24.1655 107.455 22.238 102.4 21.4008C97.3429 20.5635 92.3393 20.8279 88.5836 21.3086C86.7095 21.5485 85.1554 21.841 84.0727 22.0727C83.5315 22.1886 83.1087 22.2891 82.8231 22.3602C82.6804 22.3957 82.572 22.4238 82.5003 22.4428C82.4645 22.4522 82.4379 22.4594 82.4207 22.4641L82.4022 22.4692L82.3983 22.4702L82.3977 22.4704Z",
			fill: "#1BA290"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.9061 8.70947H17.9952V82.4806H81.9061V8.70947Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.878 0H13.964C12.8595 0 11.964 0.895431 11.964 2V25.854C11.964 26.9585 12.8595 27.854 13.964 27.854H86.878C87.9826 27.854 88.878 26.9585 88.878 25.854V2C88.878 0.895431 87.9826 0 86.878 0Z",
			fill: "#F0F1F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M86.878 2H13.964V25.854H86.878V2ZM13.964 0H86.878C87.9826 0 88.878 0.895431 88.878 2V25.854C88.878 26.9585 87.9826 27.854 86.878 27.854H13.964C12.8595 27.854 11.964 26.9585 11.964 25.854V2C11.964 0.895431 12.8595 0 13.964 0Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M62.3077 8.00951C62.3077 9.35638 63.419 10.4482 64.7659 10.4482C66.1127 10.4482 67.224 9.35638 67.224 8.00951C67.224 6.66265 66.1127 5.5708 64.7659 5.5708C63.419 5.5708 62.3077 6.66265 62.3077 8.00951Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M69.3748 8.00951C69.3748 9.35638 70.486 10.4482 71.8329 10.4482C73.1798 10.4482 74.291 9.35638 74.291 8.00951C74.291 6.66265 73.1798 5.5708 71.8329 5.5708C70.486 5.5708 69.3748 6.66265 69.3748 8.00951Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.4418 8.00951C76.4418 9.35638 77.553 10.4482 78.8999 10.4482C80.2468 10.4482 81.358 9.35638 81.358 8.00951C81.358 6.66265 80.2468 5.5708 78.8999 5.5708C77.553 5.5708 76.4418 6.66265 76.4418 8.00951Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.55 18.7124C24.55 17.6078 25.4454 16.7124 26.55 16.7124H74.2922C75.3967 16.7124 76.2922 17.6078 76.2922 18.7124V26.4613H24.55V18.7124Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M74.2922 18.7124H26.55V24.4613H74.2922V18.7124ZM26.55 16.7124C25.4454 16.7124 24.55 17.6078 24.55 18.7124V26.4613H76.2922V18.7124C76.2922 17.6078 75.3967 16.7124 74.2922 16.7124H26.55Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.878 30.6395H13.964C12.8595 30.6395 11.964 31.535 11.964 32.6395V56.4935C11.964 57.598 12.8595 58.4935 13.964 58.4935H86.878C87.9826 58.4935 88.878 57.598 88.878 56.4935V32.6395C88.878 31.535 87.9826 30.6395 86.878 30.6395Z",
			fill: "#F0F1F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M86.878 32.6395H13.964V56.4935H86.878V32.6395ZM13.964 30.6395H86.878C87.9826 30.6395 88.878 31.535 88.878 32.6395V56.4935C88.878 57.598 87.9826 58.4935 86.878 58.4935H13.964C12.8595 58.4935 11.964 57.598 11.964 56.4935V32.6395C11.964 31.535 12.8595 30.6395 13.964 30.6395Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M62.3077 38.6486C62.3077 39.9954 63.419 41.0873 64.7659 41.0873C66.1127 41.0873 67.224 39.9954 67.224 38.6486C67.224 37.3017 66.1127 36.2098 64.7659 36.2098C63.419 36.2098 62.3077 37.3017 62.3077 38.6486Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M69.3748 38.6486C69.3748 39.9954 70.486 41.0873 71.8329 41.0873C73.1798 41.0873 74.291 39.9954 74.291 38.6486C74.291 37.3017 73.1798 36.2098 71.8329 36.2098C70.486 36.2098 69.3748 37.3017 69.3748 38.6486Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.4418 38.6486C76.4418 39.9954 77.553 41.0873 78.8999 41.0873C80.2468 41.0873 81.358 39.9954 81.358 38.6486C81.358 37.3017 80.2468 36.2098 78.8999 36.2098C77.553 36.2098 76.4418 37.3017 76.4418 38.6486Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.55 49.3514C24.55 48.2469 25.4454 47.3514 26.55 47.3514H74.2922C75.3967 47.3514 76.2922 48.2469 76.2922 49.3514V57.1003H24.55V49.3514Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M74.2922 49.3514H26.55V55.1003H74.2922V49.3514ZM26.55 47.3514C25.4454 47.3514 24.55 48.2469 24.55 49.3514V57.1003H76.2922V49.3514C76.2922 48.2469 75.3967 47.3514 74.2922 47.3514H26.55Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.878 62.6715H13.964C12.8595 62.6715 11.964 63.5669 11.964 64.6715V88.5255C11.964 89.63 12.8595 90.5255 13.964 90.5255H86.878C87.9826 90.5255 88.878 89.63 88.878 88.5255V64.6715C88.878 63.5669 87.9826 62.6715 86.878 62.6715Z",
			fill: "#F0F1F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M86.878 64.6715H13.964V88.5255H86.878V64.6715ZM13.964 62.6715H86.878C87.9826 62.6715 88.878 63.5669 88.878 64.6715V88.5255C88.878 89.63 87.9826 90.5255 86.878 90.5255H13.964C12.8595 90.5255 11.964 89.63 11.964 88.5255V64.6715C11.964 63.5669 12.8595 62.6715 13.964 62.6715Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M62.3077 70.681C62.3077 72.0279 63.419 73.1197 64.7659 73.1197C66.1127 73.1197 67.224 72.0279 67.224 70.681C67.224 69.3342 66.1127 68.2423 64.7659 68.2423C63.419 68.2423 62.3077 69.3342 62.3077 70.681Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M69.3748 70.681C69.3748 72.0279 70.486 73.1197 71.8329 73.1197C73.1798 73.1197 74.291 72.0279 74.291 70.681C74.291 69.3342 73.1798 68.2423 71.8329 68.2423C70.486 68.2423 69.3748 69.3342 69.3748 70.681Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.4418 70.681C76.4418 72.0279 77.553 73.1197 78.8999 73.1197C80.2468 73.1197 81.358 72.0279 81.358 70.681C81.358 69.3342 80.2468 68.2423 78.8999 68.2423C77.553 68.2423 76.4418 69.3342 76.4418 70.681Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.55 81.3839C24.55 80.2793 25.4454 79.3839 26.55 79.3839H74.2922C75.3967 79.3839 76.2922 80.2793 76.2922 81.3839V89.1328H24.55V81.3839Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M74.2922 81.3839H26.55V87.1328H74.2922V81.3839ZM26.55 79.3839C25.4454 79.3839 24.55 80.2793 24.55 81.3839V89.1328H76.2922V81.3839C76.2922 80.2793 75.3967 79.3839 74.2922 79.3839H26.55Z",
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.5193 98.7526C41.5193 98.7526 41.5157 98.7506 41.5157 98.7506C41.5112 98.7336 41.4792 98.6153 41.2521 97.789C41.0152 96.9265 40.9909 96.8352 40.9884 96.8256C40.9882 96.8248 40.9885 96.8243 40.9893 96.8241V96.8241L40.9926 96.8232L41.0023 96.8206L41.0348 96.812C41.062 96.8049 41.1005 96.7951 41.1494 96.7832C41.2473 96.7592 41.3872 96.7266 41.5634 96.6894C41.9154 96.6153 42.4146 96.523 43.0146 96.4475C44.207 96.2974 45.834 96.2086 47.508 96.4813C49.1821 96.754 50.9659 97.3991 52.3875 98.7698C53.8249 100.156 54.7953 102.19 54.994 105.049C55.3661 110.402 53.0229 113.974 51.4892 116.312C51.3928 116.458 51.2996 116.601 51.2105 116.738C50.8266 117.329 50.5484 117.786 50.3822 118.167C50.2142 118.553 50.2251 118.721 50.2399 118.78C50.247 118.809 50.2846 118.952 50.6539 119.175C50.896 119.321 51.2383 119.474 51.7115 119.631C52.2355 119.805 52.5622 120.342 52.4265 120.878V120.878C52.2908 121.413 51.7448 121.742 51.2187 121.574C50.5836 121.371 50.0511 121.146 49.6219 120.888C48.9783 120.5 48.4762 119.978 48.2986 119.261C48.1287 118.575 48.3099 117.916 48.5488 117.368C48.7895 116.816 49.1549 116.231 49.5329 115.649C49.618 115.518 49.7054 115.384 49.7945 115.248C51.3161 112.922 53.3232 109.854 52.9988 105.188C52.8282 102.733 52.0209 101.194 50.9994 100.21C49.9622 99.2096 48.6061 98.6865 47.1865 98.4553C45.7667 98.224 44.3461 98.2956 43.2645 98.4318C42.7274 98.4994 42.2829 98.5818 41.9755 98.6465C41.822 98.6788 41.7032 98.7067 41.6249 98.7258C41.5857 98.7354 41.5566 98.7429 41.5384 98.7476L41.5193 98.7526V98.7526Z",
			fill: "#1BA290"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.099 123.709C97.505 123.709 108.373 112.927 108.373 99.6267C108.373 86.3264 97.505 75.5444 84.099 75.5444C70.6929 75.5444 59.8251 86.3264 59.8251 99.6267C59.8251 112.927 70.6929 123.709 84.099 123.709Z",
			fill: "#000246"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.4118 118.527H73.0375V131.635H80.4118V118.527Z",
			fill: "#000246"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.1604 118.527H87.7861V131.635H95.1604V118.527Z",
			fill: "#000246"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.1828 134.074C82.5767 134.074 85.3281 133.05 85.3281 131.788C85.3281 130.525 82.5767 129.501 79.1828 129.501C75.7888 129.501 73.0375 130.525 73.0375 131.788C73.0375 133.05 75.7888 134.074 79.1828 134.074Z",
			fill: "#000246"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.9313 133.768C97.3253 133.768 100.077 132.745 100.077 131.482C100.077 130.219 97.3253 129.196 93.9313 129.196C90.5374 129.196 87.7861 130.219 87.7861 131.482C87.7861 132.745 90.5374 133.768 93.9313 133.768Z",
			fill: "#000246"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.7134 101.761C89.2952 101.761 93.0095 98.0757 93.0095 93.53C93.0095 88.9843 89.2952 85.2993 84.7134 85.2993C80.1316 85.2993 76.4173 88.9843 76.4173 93.53C76.4173 98.0757 80.1316 101.761 84.7134 101.761Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.7134 96.2737C86.2407 96.2737 87.4788 95.0454 87.4788 93.5302C87.4788 92.0149 86.2407 90.7866 84.7134 90.7866C83.1861 90.7866 81.948 92.0149 81.948 93.5302C81.948 95.0454 83.1861 96.2737 84.7134 96.2737Z",
			fill: "#000246"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M106.865 94.8232C113.028 92.2065 117.352 88.5294 116.524 86.6101C115.696 84.6909 110.029 85.2562 103.867 87.8729C97.7046 90.4896 93.3803 94.1667 94.2083 96.086C95.0363 98.0053 100.703 97.4399 106.865 94.8232Z",
			fill: "#000246"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.3904 110.979C67.5527 108.363 71.8771 104.686 71.0491 102.766C70.2211 100.847 64.5543 101.412 58.392 104.029C52.2297 106.646 47.9053 110.323 48.7333 112.242C49.5613 114.162 55.2281 113.596 61.3904 110.979Z",
			fill: "#000246"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98.233 106.638C98.233 108.995 92.1158 113.649 85.3279 113.649C78.54 113.649 72.1156 109.3 72.1156 106.943C72.1156 104.586 78.54 105.114 85.3279 105.114C92.1158 105.114 98.233 104.281 98.233 106.638Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.9469 74.74C58.9869 66.0315 65.2522 57.2318 74.9409 55.0855C84.6296 52.9392 94.0727 58.2589 96.0327 66.9674C97.9927 75.676 91.5717 78.8878 81.883 81.0342C72.1943 83.1805 62.9069 83.4485 60.9469 74.74Z",
			fill: "#1BA290"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18.9562,
			y: 5.5708,
			width: 13.9844,
			height: 2.7854,
			rx: 1.3927,
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18.9562,
			y: 37.603,
			width: 13.9844,
			height: 2.7854,
			rx: 1.3927,
			fill: "#CCD1D7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18.9562,
			y: 69.6348,
			width: 13.9844,
			height: 2.7854,
			rx: 1.3927,
			fill: "#CCD1D7"
		})
	]
});
export default SvgMascot;
